module.exports = __webpack_public_path__ + "media/images/brand/page_background/right_side_spots-b85da2ccbe21af88df8230daa5d9dcda.svg";